import {Col, Row} from "reactstrap";
import Button from "../../base/button/button";
import React from "react";

const TryAgain = ({
                      onClick,
                      text = 'no search results found!',
                      buttonText = 'Search Again',
                      comingSoon = false,
                      showButton = false
                  }) => {
    return (
        <Col className=' pt-5 pb-5 justify-content-center align-items-center try-again'>
            <p className='text-sm text-center text-color-3 mb-2'>{text}</p>
            {
                showButton &&
                <Row className='w-100 no-gutters pt-2 justify-content-center align-items-center'>
                    <Button
                        variant={'outlined'}
                        color={'primary'}
                        className={'px-3'}
                        onClick={onClick}
                        hoverChildren={comingSoon ? 'Coming Soon' : buttonText}
                    >
                        {buttonText}
                    </Button>
                </Row>
            }
        </Col>
    );
}

export default TryAgain;
